import { RecommendationSection } from 'app/library/recommendation-section/models/recommendation-section.model';
import { SectionType } from '../enums/section-type.enum';
import { ISectionQuery } from '../interfaces/section.query.interface';
import { Section } from './section.model';

export class RecommendationsSection extends Section {
    recommendationSection: RecommendationSection | null;

    constructor(query?: ISectionQuery) {
        super(query);

        this._type = SectionType.Recommendations;

        if (query && query.recommendation_section) {
            this.recommendationSection = new RecommendationSection(query.recommendation_section);
        } else {
            this.recommendationSection = null;
        }
    }
}
